import React, { Fragment, useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import FilterButton from '../../components/FilterButton';

import {
  fulfillmentMethodType,
  fulfillmentMethodsType,
} from '../HomeFiltersFulfillmentControl/proptypes';

/**
 * Renders an horizontal list of filter buttons to let the consumer change the fulfillment method.
 */
const HomeFiltersFulfillmentControlMobile = ({
  selectedMethod,
  availableMethods,
  showFulfillmentSwitchControl,
  onChange,
}) => {
  const [stateMethod, setStateMethod] = useState(selectedMethod);

  useEffect(
    () => {
      setStateMethod(selectedMethod);
    },
    [selectedMethod],
  );

  if (!showFulfillmentSwitchControl) {
    return null;
  }

  return (
    <Fragment>
      {availableMethods.map(({ label, targetMethod }) => {
        const onClick = () => {
          if (targetMethod !== stateMethod) {
            setStateMethod(targetMethod);
            onChange(targetMethod);
          }
        };

        return (
          <FilterButton
            key={targetMethod}
            isSelected={stateMethod === targetMethod}
            onClick={onClick}
          >
            {label}
          </FilterButton>
        );
      })}
    </Fragment>
  );
};

HomeFiltersFulfillmentControlMobile.propTypes = {
  /**
   * The currently selected fulfillment method.
   */
  selectedMethod: fulfillmentMethodType.isRequired,
  /**
   * The list of available fulfillment methods.
   */
  availableMethods: fulfillmentMethodsType.isRequired,
  /**
   * Whether the switch control should be rendered or not.
   */
  showFulfillmentSwitchControl: PropTypes.bool.isRequired,
  /**
   * The callback to be triggered after the user selects a fulfilment option.
   */
  onChange: PropTypes.func.isRequired,
};

export default HomeFiltersFulfillmentControlMobile;
